import { render } from "./concierge-only-access.vue?vue&type=template&id=22bdfde2&scoped=true"
import script from "./concierge-only-access.vue?vue&type=script&lang=js"
export * from "./concierge-only-access.vue?vue&type=script&lang=js"

import "./concierge-only-access.vue?vue&type=style&index=0&id=22bdfde2&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bdfde2"]])

export default __exports__